import request from "@/util/request";
export function GetBanners(params) {
  return request({
    url: "/pc/Common/GetBanners",
    method: "get",
    params,
  });
}

export function ClickBanners(data) {
  return request({
    url: "/pc/Common/ClickBanners",
    method: "post",
    data,
  });
}

export function GetSiteInfo(params) {
  return request({
    url: "/pc/Common/GetSiteInfo",
    method: "get",
    params,
  });
}
export function GetLabelContent(params) {
  return request({
    url: "/pc/Common/GetLabelContent",
    method: "get",
    params,
  });
}
export function SendSMS(data) {
  return request({
    url: "/pc/Common/SendSMS",
    method: "post",
    data,
  });
}
export function Comment_GetList(params) {
  return request({
    url: "/pc/Comment/Comment_GetList",
    method: "get",
    params,
  });
}
export function Fav_Save(data) {
  return request({
    url: "/pc/Comment/Fav_Save",
    method: "post",
    data,
  });
}
export function Comment_Save(data) {
  return request({
    url: "/pc/Comment/Comment_Save",
    method: "post",
    data,
  });
}
export function Evaluate_Save(data) {
  return request({
    url: "/pc/Comment/Evaluate_Save",
    method: "post",
    data,
  });
}
export function Course_GetTypes(params) {
  return request({
    url: "/pc/Course/Course_GetTypes",
    method: "get",
    params,
  });
}
export function LeaveMessage(data) {
  return request({
    url: "/pc/Common/LeaveMessage",
    method: "post",
    data,
  });
}